export const support_phone = '888-240-0314';
export const support_email = 'support@soomolearning.com';
